<div class="subheading-container">
  <capra-icon icon="icon-info-article"></capra-icon>
  <h3 class="subheading" data-test="title">Delivery</h3>
</div>
<mode-delivery-type-selector
  [deliveryType]="deliveryType"
  [slackOptionEnabled]="slackDeliveryOptionEnabled"
  (deliveryTypeChanged)="deliveryTypeChanged.emit($event)"
></mode-delivery-type-selector>
